var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocx({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 55,
    viewBox: "0 0 46 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6 0L46 18.3333V48.5833C46 52.1272 43.1167 55 39.56 55H6.44C2.88329 55 0 52.1272 0 48.5833V6.41667C0 2.87284 2.88329 0 6.44 0H27.6Z",
    fill: "url(#paint0_linear_448_54060)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 18.333H34.3653C30.8086 18.333 27.6 15.1361 27.6 11.5923V-0.000326157L46 18.333Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6935 45.971C11.8486 45.971 12.765 45.4032 13.281 44.4824H13.3041V45.8329H14.5824V34.7607H13.2425V39.1497H13.2117C12.7342 38.275 11.8101 37.7148 10.6627 37.7148C8.64506 37.7148 7.2666 39.3415 7.2666 41.8429C7.2666 44.3443 8.65276 45.971 10.6935 45.971ZM10.9476 38.8888C12.3261 38.8888 13.2502 40.0628 13.2502 41.8429C13.2502 43.6307 12.3261 44.797 10.9476 44.797C9.53066 44.797 8.63736 43.6537 8.63736 41.8429C8.63736 40.0398 9.53066 38.8888 10.9476 38.8888Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7112 45.971C21.9214 45.971 23.4154 44.3827 23.4154 41.8429C23.4154 39.2955 21.9214 37.7148 19.7112 37.7148C17.4934 37.7148 15.9994 39.2955 15.9994 41.8429C15.9994 44.3827 17.4934 45.971 19.7112 45.971ZM19.7112 44.797C18.2943 44.797 17.3625 43.7228 17.3625 41.8429C17.3625 39.963 18.2943 38.8888 19.7112 38.8888C21.1282 38.8888 22.0523 39.963 22.0523 41.8429C22.0523 43.7228 21.1282 44.797 19.7112 44.797Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4243 40.4694C31.2549 39.0346 30.0612 37.7148 28.059 37.7148C25.8489 37.7148 24.378 39.3262 24.378 41.8429C24.378 44.4134 25.8566 45.971 28.0744 45.971C29.8918 45.971 31.2318 44.8507 31.4397 43.2624H30.1229C29.8918 44.2215 29.1756 44.797 28.0821 44.797C26.696 44.797 25.741 43.6998 25.741 41.8429C25.741 40.0321 26.6806 38.8888 28.0667 38.8888C29.2449 38.8888 29.9226 39.6024 30.1151 40.4694H31.4243Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5058 42.7944L37.4233 45.8329H38.9096L36.2451 41.7892L38.9481 37.853H37.4541L35.552 40.8454H35.5212L33.596 37.853H32.102L34.7819 41.8429L32.0558 45.8329H33.542L35.475 42.7944H35.5058Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_448_54060",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5895FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387CF4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocx);
export default __webpack_public_path__ + "static/media/docx.d78f67a1753cff49ade701ec2b44bf83.svg";
export { ForwardRef as ReactComponent };